import { useState } from "react";
import { faqs } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-16">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-[0.9fr_1.1fr]">
        <div>
          <SectionHeading
            eyebrow="常见问题"
            title="关于本站，你可能想知道的"
            desc="下面整理了使用本页浏览小视频时最常见的几个问题。点击问题即可展开查看答案。"
          />

          <div className="mt-6 rounded-lg border border-secondary-200 bg-secondary-50 p-5">
            <p className="flex items-center gap-2 text-sm font-semibold text-secondary-900">
              <i className="ri-information-line text-base"></i>
              小提示
            </p>
            <p className="mt-2 text-sm leading-relaxed text-secondary-900/80">
              本页所有筛选、搜索与标签切换都只作用于当前页面已有的内容，完全在你的浏览器内完成，无需登录，也不会上传任何个人信息。
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => toggle(index)}
                  aria-expanded={isOpen}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
                >
                  <h3 className="text-sm font-semibold text-foreground-950 md:text-base">{item.q}</h3>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-base`}></i>
                  </span>
                </button>
                {isOpen ? (
                  <div className="border-t border-background-200 px-4 py-4 md:px-5">
                    <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}